var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { defaultProps, propTypes } from './const';
import Slider from './Slider';
import fieldLocalState from '../../utils/form/fieldLocalState';
import { withTheme } from '../../theme';
class DRNSlider extends Component {
    render() {
        const _a = this.props, { onChange, value, minimumTrackTintColor, maximumTrackTintColor, thumbTintColor, theme } = _a, restProps = __rest(_a, ["onChange", "value", "minimumTrackTintColor", "maximumTrackTintColor", "thumbTintColor", "theme"]);
        return (<Slider {...restProps} value={value} onValueChange={this.props.onChange} minimumTrackTintColor={minimumTrackTintColor ? minimumTrackTintColor : theme.tintPrimary} maximumTrackTintColor={maximumTrackTintColor ? maximumTrackTintColor : theme.lightSecondary} thumbTintColor={thumbTintColor}/>);
    }
}
DRNSlider.propTypes = propTypes;
DRNSlider.defaultProps = defaultProps;
export default fieldLocalState(withTheme(DRNSlider));
